import { MapPinIcon } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";

export const WithLocationStudentCard = ({ location }: { location: string }) => {
  const { t } = useTranslation();
  return (
    <>
      <p className="flex max-w-full items-center gap-1 truncate text-xs font-normal text-muted-foreground">
        <MapPinIcon className="h-4 w-4 flex-shrink-0" />
        <span className="truncate">
          {location || t("studentCarousel.noLocation")}
        </span>
      </p>
    </>
  );
};
